import { Directive, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';
import { MuiStickyService } from './mui-sticky.service';


/**
 * Add this directive to an element to make it a sticky offset anchor (e.g. a fixed header). Sticky elements that have the
 * muiSticky directive applied will position themselves right below this element.
 *
 * Make sure there is always only one sticky offset anchor in the DOM at a time. Multiple anchors will cause undefined behavior
 * and is not supported by now.
 */
@Directive({
  selector: '[muiStickyOffsetAnchor]',
  standalone: false
})
export class MuiStickyOffsetAnchorDirective implements OnInit, OnDestroy {

  readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  readonly stickyService = inject(MuiStickyService);

  ngOnInit(): void {
    this.stickyService.setOffsetAnchor(this.host.nativeElement);
  }

  ngOnDestroy(): void {
    this.stickyService.removeOffsetAnchor(this.host.nativeElement);
  }
}
